// @ts-nocheck
import { object, array } from "yup";

export default object().shape({
  notified_brand_ids: array(),
});
